import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const claimValidationRules = {
  day: {
    max: 31,
    min: 1,
  },
  month: {
    max: 12,
    min: 1,
  },
  year: {
    max: dayjs().year(),
    min: dayjs().year() - 5,
  },
}
